import script from "./diary-authentication-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./diary-authentication-modal.vue?vue&type=script&setup=true&lang=ts"

import "./diary-authentication-modal.vue?vue&type=style&index=0&id=21dada4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21dada4c"]])

export default __exports__